(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2492],{

/***/ 64778:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./affiliates1.png": 64833,
	"./affiliates2.png": 99294,
	"./article1.png": 94590,
	"./article2.png": 1923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64778;

/***/ }),

/***/ 3725:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]",
      function () {
        return __webpack_require__(25514);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/affiliates1.c0070cc6.png","height":615,"width":690,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAM1BMVEX+5d704NX+7+v7+vjd5M7r5+TP2rz/5+KU2pOk2J3Oy8zi3+nGxcPq4dHf4tPZz+7T0dDOjqjRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAN0lEQVR4nB3IQRKAIBAEsQYWZhZQ/P9rLc0xgGLw0ZUeApW086+0XYDa74gKauvM1YT6ns/uegEgZAE8oolrqQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 99294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/affiliates2.7641f663.png","height":615,"width":690,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAMFBMVEXY9P7Y8vbm7db9yTrn+PnLzc/l57jr4Jry1m/3+PjExsbX3N3g3uji5sT30FzUzu5ACGK5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAANUlEQVR4nB3ISQ4AIQzEQKeTsMP8/7cj8MkqwIqMm3Z9Y9W9PGl+2qUISQH09eXqwMyRY/IDFB0A3NgNDvgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 94590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/article1.6820bc2f.png","height":460,"width":694,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAMFBMVEUSJ0slOFk9U3Q1SWwdMVRZaIEGHUNPZ4hGXYJlfJoDFzwrQGNyiqrAx9KLlKbZ2+SrMHKJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVR4nAXBhwEAIAzDMKcDyv7/WySQ7VEeNPIkARN/FwVNSpNgWfXRnQ8QkQC4xF0Z1gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 1923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/article2.ad41d0ad.png","height":458,"width":726,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAHlBMVEXqwgPluwTyzQDuxwHasw/Ooh/XsC3Rr1G9m2O/p50bfbN2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKElEQVR4nCXJwQ0AIAwDsQtJW9h/YYTw16zHNgbQNEln6myEFFX9Al0KGABqPGLlSwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 46591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43138);
/* harmony import */ var _AppContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2208);
/* harmony import */ var _components_Cards_FeatureCards__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7041);
/* harmony import */ var _components_Buttons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46687);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10447);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56475);
/* harmony import */ var react_icons_hi2__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69274);











const StickyLoginCard = (param)=>{
    let { pageProduct ="" , cardWidth ="xs:w-[360px]" , title , description  } = param;
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_AppContext__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z);
    const content = {
        default: {
            title: "Create a free BoloForms account today!",
            description: "Create your free account today and start creating your own digital signature.",
            link: "https://sheetgod.boloforms.com/login?from=".concat(context.globalData.from || "STICKY_CARD")
        },
        approvals: {
            title: "Create a free BoloForms account today!",
            description: "Create your free account today and start creating your approval workflows.",
            link: "https://approval-dashboard.boloforms.com/login?from=".concat(context.globalData.from || "STICKY_CARD")
        },
        signature: {
            title: "Tired of nonsense pricing of DocuSign?",
            description: "Start taking digital signatures with BoloSign and save money.",
            link: "https://signature.boloforms.com/register?from=".concat(context.globalData.from || "STICKY_CARD")
        },
        "timer-proctor": {
            title: "Create a free BoloForms account today!",
            description: "Create your free account today and start creating tests using BoloForms Timer + Proctor.",
            link: "https://dashboard.boloforms.com/login?from=".concat(context.globalData.from || "STICKY_CARD")
        },
        sheetgod: {
            title: "Create a free BoloForms account today!",
            description: "Create your free account today and start enhancing your sheets using BoloForms SheetGod.",
            link: "https://sheetgod.boloforms.com/login?from=".concat(context.globalData.from || "STICKY_CARD")
        },
        taxes: {
            title: "Create a free BoloForms account today!",
            description: "Create your free account today and start creating your own digital signature.",
            link: "https://signature.boloforms.com/login?from=".concat(context.globalData.from || "STICKY_CARD").concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_8__/* .createUTMQueryParams */ .T0)({
                utmData_: context.globalData.utmData,
                from: "STICKY_CARD"
            }))
        }
    };
    const contentToDisplay = pageProduct && content[pageProduct] ? content[pageProduct] : content.signature;
    return(//   <div className="max-w-screen-mxl mx-auto">
    //   {
    //     <FeatureCards
    //       cardsData={featuresData}
    //       featuresStyling={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-10`}
    //     />
    //   }
    //   <div className="mt-10 flex justify-center items-center">
    //     <ButtonPrimary buttonText={`All Features`} buttonUrl={`#`} />
    //   </div>
    // </div>
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full ".concat(cardWidth, " mx-auto border border-surface-dark  px-6 pt-7 pb-9 flex flex-col gap-4 text-center justify-center items-center rounded-xl bg-surface"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_4__.BASE_ASSETS_URL, "/boloforms-signature/boloforms-logo.png"),
                className: "w-auto h-auto rounded-full",
                width: 10,
                height: 10,
                alt: "BoloForms"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-2xl",
                        children: title ? title : contentToDisplay.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-gray-600",
                        children: description ? description : contentToDisplay.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: " flex justify-center items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_9__/* .CLMButtonPrimary */ .IS, {
                            buttonText: "Get started for free",
                            buttonUrl: contentToDisplay.link,
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_10__/* .HiArrowLongRight */ .P8b, {})
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (StickyLoginCard);


/***/ }),

/***/ 18954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43138);





const BlogCard = (param)=>{
    let { blogImage , image , imageURL , imageWidth ="w-full md:h-[250px] lg:h-[367px] xl:h-[370px]" , title , genre , date , owner , desc , blogUrl , genreColor , customTitle , imageBorders , localAsset =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: blogUrl,
        target: "_blank",
        className: "group w-full flex flex-col gap-6 text-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full flex items-center justify-center mx-auto",
                children: [
                    (imageURL || image) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full h-[367px] bg-surface-light ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: imageURL ? imageURL : localAsset ? __webpack_require__(64778)("./".concat(image)) : "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_4__.BASE_ASSETS_URL, "/v2/articles/").concat(image),
                            alt: title,
                            width: 100,
                            height: 100,
                            className: "w-full h-full object-cover"
                        })
                    }),
                    blogImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full h-[367px] bg-surface-light ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: "".concat(blogImage),
                            alt: title,
                            width: 100,
                            height: 100,
                            className: "w-full h-full object-cover"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-left font-bold md:px-0 px-2 ".concat(customTitle ? customTitle : "text-xl leading-snug lg:text-[28px] md:leading-[36px]"),
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "md:px-0 px-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-left md:text-[22px] md:leading-[32px] text-base leading-snug font-medium text-gray-600",
                        children: desc
                    }),
                    owner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-start items-center gap-2 mt-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                width: 48,
                                height: 48,
                                src: owner === null || owner === void 0 ? void 0 : owner.img,
                                alt: "Owner",
                                className: "rounded-full"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col items-start",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "md:text-xl text-base font-semibold text-gray-800",
                                        children: owner === null || owner === void 0 ? void 0 : owner.name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "md:text-base text-sm font-semibold text-gray-500",
                                        children: owner === null || owner === void 0 ? void 0 : owner.title
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogCard);


/***/ }),

/***/ 59183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_SignatureRegister__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71605);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46687);
/* harmony import */ var _components_AppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2208);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10447);
/* harmony import */ var _components_google_ads_Buttons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71631);
/* harmony import */ var react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69274);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56475);









const CtaOne = (param)=>{
    let { heading1 , heading2 , heading3 , paragraph , paragraphStyling , buttonsStyling , buttonPrimaryText , buttonPrimaryUrl , buttonPrimaryIcon , buttonPrimaryBorderShadow , buttonPrimaryNewTab , buttonPrimaryBg , buttonSecondaryText , buttonSecondaryUrl , buttonSecondaryIcon , buttonSecondaryNewTab , signaturePopupOpen  } = param;
    var _context_globalData, _context_globalData_utmData;
    const context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_components_AppContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
    const [signaturePopup, setSignaturePopup] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        open: false,
        mode: "register"
    });
    const [is1DollarTrialCampaignState, setIs1DollarTrialCampaignState] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const isSignaturePage = signaturePopupOpen;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        var _context_globalData, _context_globalData_utmData;
        setIs1DollarTrialCampaignState((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__/* .is1DollarTrialCampaign */ .Og)({
            utm_campaign: context === null || context === void 0 ? void 0 : (_context_globalData = context.globalData) === null || _context_globalData === void 0 ? void 0 : (_context_globalData_utmData = _context_globalData.utmData) === null || _context_globalData_utmData === void 0 ? void 0 : _context_globalData_utmData.utm_campaign
        }));
    }, [
        context === null || context === void 0 ? void 0 : (_context_globalData = context.globalData) === null || _context_globalData === void 0 ? void 0 : (_context_globalData_utmData = _context_globalData.utmData) === null || _context_globalData_utmData === void 0 ? void 0 : _context_globalData_utmData.utm_campaign
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col gap-7 sm:gap-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SignatureRegister__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                isPopupOpen: signaturePopup.open && isSignaturePage,
                mode: signaturePopup.mode,
                setIsPopupOpen: (value)=>setSignaturePopup((prev)=>({
                            ...prev,
                            open: value
                        })),
                setMode: (mode)=>setSignaturePopup((prev)=>({
                            ...prev,
                            mode: mode
                        }))
            }),
            heading1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "font-bold text-4xl sm:text-5xl lg:text-6xl mxl:text-7xl",
                children: heading1
            }),
            heading2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "font-bold leading-[45px] sm:leading-[55px] lg:leading-tight text-[36px] sm:text-[48px] lg:text-5xl",
                children: heading2
            }),
            heading3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "font-bold text-2xl sm:text-3xl",
                children: heading3
            }),
            paragraph && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-lg sm:text-xl ".concat(paragraphStyling),
                children: paragraph
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-2 flex items-center flex-wrap gap-4 sm:gap-6 ".concat(buttonsStyling && buttonsStyling),
                children: [
                    buttonPrimaryText && (isSignaturePage ? is1DollarTrialCampaignState ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_google_ads_Buttons__WEBPACK_IMPORTED_MODULE_6__/* .Button1 */ .g, {
                        btnText: buttonPrimaryText,
                        bgColor: buttonPrimaryBg || "bg-violet-500",
                        textColor: "text-white",
                        border: "border border-violet-500 ",
                        showLoading: false,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__/* .HiArrowLongRight */ .P8b, {}),
                        borderShadow: buttonPrimaryBorderShadow !== null && buttonPrimaryBorderShadow !== void 0 ? buttonPrimaryBorderShadow : true,
                        px: "px-5"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Buttons__WEBPACK_IMPORTED_MODULE_3__/* .ButtonPrimaryDiv */ .gf, {
                        buttonText: buttonPrimaryText,
                        onclick: ()=>setSignaturePopup((prev)=>({
                                    ...prev,
                                    open: true
                                })),
                        buttonUrl: buttonPrimaryUrl,
                        icon: buttonPrimaryIcon,
                        borderShadow: buttonPrimaryBorderShadow,
                        newTab: buttonPrimaryNewTab,
                        bgColor: buttonPrimaryBg
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__/* .CLMButtonPrimary */ .IS, {
                        buttonText: buttonPrimaryText,
                        buttonUrl: buttonPrimaryUrl,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__/* .HiArrowLongRight */ .P8b, {})
                    })),
                    buttonSecondaryText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__/* .CLMButtonSecondaryBorder */ .AL, {
                        buttonText: buttonSecondaryText,
                        buttonUrl: buttonSecondaryUrl
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CtaOne);


/***/ }),

/***/ 7041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const FeatureCards = (param)=>{
    let { cardsData , cardsStyling =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8",
        children: cardsData.map((card, index)=>{
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col gap-6 border-2 px-6 sm:px-10 pb-10 pt-16 rounded-xl cardBorders transition-all duration-500 ease-in-out border-gray-600 text-center ".concat(card.styling),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center justify-center w-[100px] h-[100px] mx-auto",
                        children: card.icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-5xl lg:text-5xl flex justify-center items-center h-full w-full bg-white rounded-full",
                            children: card.icon
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col gap-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "text-2xl font-bold",
                                children: card.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-xl",
                                children: card.description
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FeatureCards);


/***/ }),

/***/ 39569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ featuredBlogs; }
/* harmony export */ });
const featuredBlogs = [
    {
        image: "",
        imageURL: "https://boloforms.ghost.io/content/images/2025/07/ChatGPT-Image-Jul-2--2025--05_49_16-PM.png",
        title: "The 5 Best AI Contract Review Software Tools for 2025",
        genreColor: "bg-red-100",
        genre: "CLM",
        date: "Jul 21, 2025",
        blogUrl: "https://www.bolosign.com/blog/the-5-best-ai-contract-review-software-tools-for-2025/",
        desc: "Compare the best AI contract review tools for 2025. See features, benefits, and practical tips to implement them at scale. Explore BoloSign’s unified solution.",
        owner: {
            img: "https://i.imgur.com/CbNehZg.png",
            name: "Paresh Deshmukh",
            title: "Co-Founder, BoloSign"
        }
    },
    {
        image: "",
        imageURL: "https://boloforms.ghost.io/content/images/2025/07/ChatGPT-Image-Jul-4--2025--05_10_14-PM.png",
        title: "Are Clickwrap Agreements Legally Binding?",
        genreColor: "bg-green-100",
        genre: "CLM",
        date: "Jul 21, 2025",
        blogUrl: "https://www.bolosign.com/blog/are-clickwrap-agreements-legally-binding/",
        desc: "Learn if clickwrap agreements are legally binding, how they work, and key best practices for enforceability.",
        owner: {
            img: "https://i.imgur.com/CbNehZg.png",
            name: "Paresh Deshmukh",
            title: "Co-Founder, BoloSign"
        }
    }
];



/***/ }),

/***/ 25514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/StickyLoginCard/index.jsx
var StickyLoginCard = __webpack_require__(46591);
// EXTERNAL MODULE: ./utils/useDeviceSize.js
var useDeviceSize = __webpack_require__(66285);
// EXTERNAL MODULE: ./components/v2/CTA/CtaOne.jsx
var CtaOne = __webpack_require__(59183);
// EXTERNAL MODULE: ./constants/blogs.js
var blogs = __webpack_require__(39569);
// EXTERNAL MODULE: ./components/v2/Blog/BlogCard.jsx
var BlogCard = __webpack_require__(18954);
// EXTERNAL MODULE: ./constants/constants.js
var constants = __webpack_require__(43138);
;// CONCATENATED MODULE: ./components/v2/Blog/FeaturedBlogs.jsx






const FeaturedBlogs = (param)=>{
    let { header =true , heading2 ="Take a Look at Our Featured Articles" , paragraph ="These articles will guide you on how to simplify office work, boost your efficiency, and concentrate on expanding your business." , blogCards  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full flex flex-col",
        children: [
            header && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center max-w-screen-xl md:px-20 px-6 mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaOne/* default */.Z, {
                        heading2: heading2,
                        paragraph: paragraph,
                        paragraphStyling: "max-w-[600px] mx-auto"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-16 sm:mt-6 flex flex-col md:flex-row gap-6 sm:max-w-[80%] md:max-w-full mx-auto",
                children: blogCards.map((card, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCard/* default */.Z, {
                        ...card
                    }, index))
            })
        ]
    });
};
/* harmony default export */ var Blog_FeaturedBlogs = (FeaturedBlogs);

;// CONCATENATED MODULE: ./pages/blog/[slug].jsx


// import Link from "next/link";

// import styles from "../../styles/Home.module.css";


// import CtaButton from "../../components/CtaButton";

// import BlogPopUpPrimary from "../../components/BlogPopUpPrimary";
// import BlogPopUpSecondary from "../../components/BlogPopUpSecondary";




const Post = (props)=>{
    var _post_primary_tag, _post_html_replaceAll, _post_html;
    // console.log(props);
    const { post  } = props;
    // console.log(post.html);
    const [width, height] = (0,useDeviceSize/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const [displayPopUpPrimary, setPopUpPrimary] = (0,react.useState)(true);
    const [displayPopUpSecondary, setPopUpSecondary] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        (()=>{
            // Check if the user has already subscribed the primary pop up
            if (localStorage.getItem("blogPopUpPrimary") === "true") {
                setPopUpPrimary(false);
                // Check if the user has already subscribed the secondary pop up
                if (localStorage.getItem("blogPopUpSecondary") !== "true") setPopUpSecondary(true);
            }
        })();
    }, []);
    if (router.isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
            children: "Loading..."
        });
    }
    const pageProduct = (post === null || post === void 0 ? void 0 : (_post_primary_tag = post.primary_tag) === null || _post_primary_tag === void 0 ? void 0 : _post_primary_tag.slug) || "";
    const closePrimaryPopUp = ()=>{
        setPopUpPrimary(false);
        // Show secondary pop up only if the user has not subscribed to it
        if (localStorage.getItem("blogPopUpSecondary") !== "true") setTimeout(()=>setPopUpSecondary(true), 5000);
    };
    const closeSecondaryPopUp = ()=>{
        setPopUpSecondary(false);
    };
    var _post_meta_description, _post_meta_title, _post_meta_description1;
    // console.log(post);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full md:mt-20 mt-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: post === null || post === void 0 ? void 0 : post.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: (_post_meta_description = post.meta_description) !== null && _post_meta_description !== void 0 ? _post_meta_description : post.excerpt
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: (_post_meta_title = post.meta_title) !== null && _post_meta_title !== void 0 ? _post_meta_title : post.excerpt
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: (_post_meta_description1 = post.meta_description) !== null && _post_meta_description1 !== void 0 ? _post_meta_description1 : post.excerpt
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/blog/".concat(post.slug, "/")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/blog/".concat(post.slug, "/")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/blog/".concat(post.slug, "/")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-screen-xl mx-auto px-4 md:px-8 txl:px-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center max-w-screen-lg mx-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaOne/* default */.Z, {
                            heading2: post === null || post === void 0 ? void 0 : post.title,
                            paragraph: post === null || post === void 0 ? void 0 : post.meta_description,
                            paragraphStyling: "max-w-screen-md mx-auto"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full mx-auto mt-8 mb-10 sm:mb-16 border border-black rounded-xl p-4 md:p-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: post === null || post === void 0 ? void 0 : post.feature_image,
                            width: "10",
                            height: "10",
                            className: "w-full h-auto rounded-xl",
                            alt: post === null || post === void 0 ? void 0 : post.feature_image_alt
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-y-10 sm:gap-y-16 z-10 relative md:mt-[20px] lg:flex-row-reverse justify-between lg:gap-12 xxl:gap-20 mx-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "self-center lg:self-start lg:sticky lg:top-[140px] flex justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyLoginCard/* default */.Z, {
                                    pageProduct: pageProduct
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "website-blogs flex-1 break-words tracking-wide",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: (_post_html_replaceAll = post === null || post === void 0 ? void 0 : (_post_html = post.html) === null || _post_html === void 0 ? void 0 : _post_html.replaceAll("<p", "<p class='my-4' ")) === null || _post_html_replaceAll === void 0 ? void 0 : _post_html_replaceAll.replaceAll("<h2", "<h2 class='my-4' ")
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center flex-row gap-4 flex-wrap mt-10 py-4 border-y border-gray-300",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[55px] h-[55px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            className: "w-full rounded-full object-cover",
                                            loading: "lazy",
                                            src: "https://i.imgur.com/CbNehZg.png",
                                            width: 100,
                                            height: 100,
                                            alt: "paresh"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "",
                                                children: "Paresh Deshmukh"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "",
                                                children: "Co-Founder, BoloForms"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-lg",
                                    children: new Date(post.published_at).toShortFormat()
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-w-screen-mxl mx-auto px-4 md:px-8 txl:px-0 my-20 md:mt-32",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog_FeaturedBlogs, {
                    blogCards: blogs/* featuredBlogs */.X
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (Post);
{
/* {displayPopUpPrimary && (
        <BlogPopUpPrimary
          closePopUp={closePrimaryPopUp}
          product={pageProduct}
        />
      )}
      {displayPopUpSecondary && (
        <BlogPopUpSecondary
          closePopUp={closeSecondaryPopUp}
          product={pageProduct}
        />
      )} */ }{
/*<h4 className="pt-5 pb-8 text-2xl font-semibold">{post.title}</h4>*/ }{
/*<div className="flex my-2">*/ }{
/*  <Image*/ }{
/*    className="w-8 h-8 rounded-full"*/ }{
/*    src="https://blog.boloforms.com/content/images/size/w100/2022/07/paresh-website-photo.jpeg"*/ }{
/*    alt="Paresh from BoloForms"*/ }{
/*    width={50}*/ }{
/*    height={50}*/ }{
/*  />*/ }{
/*  <div className="ml-2">*/ }{
/*    <div className="font-medium text-sm">Paresh from BoloForms</div>*/ }{
/*    <div className="text-xs text-slate-400">*/ }{
/*      {new Date(post.published_at).toDateString()} - {post.reading_time}{" "}*/ }{
/*      min*/ }{
/*    </div>*/ }{
/*  </div>*/ }{
/*</div>*/ }{
/*<br />*/ }{
/*{post.feature_image && (*/ }{
/*  <Image*/ }{
/*    src={post.feature_image}*/ }{
/*    alt={post.title}*/ }{
/*    className="mr-6 max-w-[120px] sm:max-w-[300px] md:max-w-[400px] text-xs h-full object-cover rounded-l-xl"*/ }{
/*    // blurDataURL="data:..." automatically provided*/ }{
/*    // placeholder="blur" // Optional blur-up while loading*/ }{
/*    width={width < 620 ? 120 : 300}*/ }{
/*    height="100"*/ }{
/*    // blurDataURL="data:..." automatically provided*/ }{
/*    // placeholder="blur" // Optional blur-up while loading*/ }{
/*  />*/ }{
/*)}*/ }{
/*<div className="mt-20  flex flex-col items-center">*/ }{
/*  <h4 className="text-xl font-semibold capitalize">*/ }{
/*    Try BoloForms for Free*/ }{
/*  </h4>*/ }{
/*  <div className="-mt-12">*/ }{
/*    <CtaButton productName={"Approvals"} />*/ }{
/*  </div>*/ }{
/*</div>*/ }

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(3725); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);